import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pesc-type-grid',
  templateUrl: './pesc-type-grid.component.html',
  styleUrls: ['./pesc-type-grid.component.css']
})
export class PescTypeGridComponent implements OnInit {

  title = "Project Environment and Safety Compliances";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/pe-sc-type/pesc-type-grid/pesc-type-grid.component.ts